import React, { useEffect, useState } from 'react';
import RequestView from './RequestView';
import useRequest from 'src/hooks/api/useRequest';
import Request from 'src/interfaces/api/Request';
import useSite from 'src/hooks/api/useSite';
import Site from 'src/interfaces/api/Site';
import useContact from 'src/hooks/api/useContact';
import Contact from 'src/interfaces/api/Contact';

const RequestViewContainer = ({ match, history, ...props }) => {
  const { get, updateStatus, updateIssueId } = useRequest();
  const [, setRequestLoading] = useState(false);
  const [request, setRequest] = useState<Request>();
  const [error, setError] = useState<string>();

  const { get: getSite } = useSite();
  const { getByCustomerAccess: getContactsByCustomerAccessId } = useContact();

  const [site, setSite] = useState<Site>();
  const [, setSiteLoading] = useState(false);

  const [creator, setCreator] = useState<Contact>();
  const [, setCreatorLoading] = useState(false);

  const { id } = match.params;

  const handleGoBack = () => {
    history.push('/dashboard/requests');
  };

  const handleUpdateIssueId = async (requestId: string, issueId: string): Promise<Request> => {
    try {
      const request = await updateIssueId(requestId, issueId);
      setRequest(request);
      return request;
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const handleUpdateStatus = async (requestId: string, newStatus: string, closedReason?: string): Promise<Request> => {
    try {
      const request = await updateStatus(requestId, newStatus, closedReason);
      setRequest(request);
      return request;
    } catch (e) {
      throw new Error(e.message);
    }
  };

  useEffect(() => {
    if (id) {
      setError(undefined);
      setRequestLoading(true);
      get(id)
        .then((request) => {
          setRequestLoading(false);
          setRequest(request);
        })
        .catch((error) => {
          setRequestLoading(false);
          setError(error.message);
        });
    }
  }, [id]);

  useEffect(() => {
    if (request && site?.id !== request.siteId) {
      setSiteLoading(true);
      getSite(request.siteId)
        .then((site) => {
          setSiteLoading(false);
          setSite(site);
        })
        .catch(() => {
          setSiteLoading(false);
        });
    }
  }, [request]);

  useEffect(() => {
    if (request && creator?.id !== request.creatorId) {
      setCreatorLoading(true);
      getContactsByCustomerAccessId([request.creatorId])
        .then((collection) => {
          setCreatorLoading(false);
          setCreator(collection.items[0]);
        })
        .catch(() => {
          setCreatorLoading(false);
        });
    }
  }, [request]);

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <RequestView
      goBack={handleGoBack}
      updateStatus={handleUpdateStatus}
      updateIssueId={handleUpdateIssueId}
      request={request}
      site={site}
      creator={creator}
      {...props}
    />
  );
};

export default RequestViewContainer;
